import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dummy-register-page',
  templateUrl: './dummy-register-page.component.html',
  styleUrls: ['./dummy-register-page.component.scss']
})
export class DummyRegisterPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
